import { useState } from "react";
import { ModalComponent } from "..";
import { useLazyGetUserProfileQuery } from "../../../redux/features/auth/auth.api";
import { useUploadCooperativeCertificateMutation } from "../../../redux/features/cooperative/cooperative.api";
import { FileUploadInput } from "../../inputs/fileUploadInput";

export const UploadCertificateModal = ({
  modalOpen,
  onModalClose = () => {},
}: {
  modalOpen: boolean;
  onModalClose: () => void;
}) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const [uploadDoc, { isLoading: uploadingDoc }] =
    useUploadCooperativeCertificateMutation();

  const [fetchProfile] = useLazyGetUserProfileQuery();

  return (
    <ModalComponent
      isModalOpen={modalOpen}
      onModalClose={() => {
        setUploadedFiles([]);
        onModalClose();
      }}
      title="Certificate of Registration"
      subTitle="This is required to verify your cooperative as a legal entity."
      modalClassName=""
      isProceedDisabled={uploadedFiles.length < 1 || uploadingDoc}
      isLoading={uploadingDoc}
      onProceedClick={async () => {
        const formData = new FormData();
        formData.append("file", uploadedFiles[0]);

        const resp = await uploadDoc(formData);

        if (resp.data?.success) {
          setUploadedFiles([]);
          onModalClose();
          fetchProfile();
        }
      }}
    >
      <FileUploadInput
        maxNumberOfFiles={1}
        handleChange={(files) => {
          setUploadedFiles(files);
        }}
        selectedFiles={uploadedFiles}
        accept="image/*,.pdf"
        types="PNG, JPG, PDF"
      />
    </ModalComponent>
  );
};
